<p-menubar class="w-full">
  <ng-template pTemplate="start">
    <div class="flex align-items-center gap-6 ml-3">
      <img src="../../../../assets/img/abertis-logo.png" alt="Logo" class="logo" />
      @if (userName) {
        <div class="flex align-items-center gap-2">
          @if (selectedRoad) {
            <p-dropdown
              [options]="roads"
              [(ngModel)]="selectedRoad"
              placeholder="Selecciona una carretera"
              class="dropdown-static-road"
              optionLabel="text"
              (onChange)="accessRoad()"
            ></p-dropdown>
          }

          <p-button
            icon="pi pi-info-circle"
            text="true"
            class="new-tab-button"
            (onClick)="openRoadInfoPanel($event)"
          />
        </div>
      }
    </div>
  </ng-template>
  <ng-template pTemplate="end">
    <div class="flex align-items-center gap-2 mr-3">
      @if (userName) {
        @if (selectedRoad) {
          @if (hasUnreadAlertEvents) {
            <p-button
              (onClick)="notificationspanel.toggle($event)"
              [icon]="isNotificationsMuted ? 'pi pi-bell-slash' : 'pi pi-bell'"
              text="true"
              class="new-tab-button"
              pBadge
              severity="danger"
            />
          }
          @else {
            <p-button
              [icon]="isNotificationsMuted ? 'pi pi-bell-slash' : 'pi pi-bell'"
              text="true"
              (onClick)="notificationspanel.toggle($event)"
              class="new-tab-button"
            />
          }

          @if ((isAdmin$ | async) || (isCoordinator$ | async)) {
            <p-menu #adminMenu [model]="adminNavItems" [popup]="true" />
            <p-button
              (onClick)="adminMenu.toggle($event)"
              icon="pi pi-cog"
              text="true"
              class="admin-menu"
            />
          }
          <p-button
            (onClick)="openNewTab()"
            icon="pi pi-external-link"
            text="true"
            class="new-tab-button"
          />
        }
        <p-avatar [label]="avatarName" class="mr-2" shape="circle"></p-avatar>
        <p-dropdown
          [options]="logoutOptions"
          [(ngModel)]="logoutOptionSelected"
          [placeholder]="userName"
          class="w-full mb-3 dropdown-menu"
          (onChange)="logout()"
        ></p-dropdown>
      }
    </div>
  </ng-template>
</p-menubar>
@if (selectedRoad) {
  <p-tabMenu
    class=""
    [model]="navItems"
    [activeItem]="activeNavItem"
    (activeItemChange)="onActiveItemChange($event)"
  />
}

<!-- websocket notifications overlay panel -->
<p-overlayPanel #notificationspanel  [appendTo]="'body'">
  <div class="flex flex-column gap-3">
    <div class="notifications-section">
      <div class="flex justify-content-center">
        <p-button
          label="Ver"
          class="text-button mr-2"
          [outlined]="true"
          icon="pi pi-eye"
          (onClick)="navigateToAlerts()"
          [disabled]="!notifications || notifications.length === 0"
        />
        <p-button
          label="Limpiar"
          class="text-button mr-2"
          [outlined]="true"
          icon="pi pi-times"
          (onClick)="clearNotifications()"
          [disabled]="!notifications || notifications.length === 0"
        />
        <p-button
          [label]="isNotificationsMuted ? 'Activar' : 'Silenciar'"
          class="text-button mr-2"
          [outlined]="true"
          [icon]="isNotificationsMuted ? 'pi pi-bell' : 'pi pi-bell-slash'"
          (onClick)="muteNotifactions()"
        />
        <p-button
          label="Estado"
          class="text-button mr-2"
          [outlined]="true"
          icon="pi pi-info-circle"
          (onClick)="notificationsStatePanel.toggle($event)"
        />
      </div>
      <div *ngIf="isNotificationsMuted" class="text-sm text-red-500 text-center">
        Las notificaciones sonoras están desactivadas
      </div>
    </div>

    <div *ngIf="notifications.length > 0; else emptyState">
      <ul class="list-none p-0 m-0 flex flex-column gap-3">
        <li *ngFor="let notification of notifications" class="flex align-items-center gap-2">
          <div>
            <span class="font-medium">{{ notification.message }}</span>
            <div class="text-sm text-color-secondary" style="overflow-wrap: anywhere; word-break: break-word;">
              {{ notification.context }} - {{ notification.timestamp }}
            </div>
          </div>
        </li>
      </ul>
    </div>
    <ng-template #emptyState>
      <div class="text-center text-color-secondary p-3">
        No hay notificaciones pendientes
      </div>
    </ng-template>
  </div>
</p-overlayPanel>
<!-- websocket notifications overlay panel -->

<!-- websocket state overlay panel -->
<p-overlayPanel #notificationsStatePanel [appendTo]="'body'">
  <div class="flex flex-column gap-3">

    <div class="diagnostics-header">
      <div class="diagnostics-title">Diagnóstico de conexión al sistema de alertas</div>
    </div>

    <div class="diagnostics-grid">
      <div class="diagnostics-item">
        <span class="diagnostics-label">Carretera</span>
        <span class="diagnostics-value diagnostics-wrap">
          {{ websocketDiagnostics?.roadName || websocketDiagnostics?.roadId || 'No disponible' }}
        </span>
      </div>
      <div class="diagnostics-item">
        <span class="diagnostics-label">Estado</span>
        <span class="diagnostics-value">{{ getWebSocketStatusLabel(websocketDiagnostics?.status) }}</span>
      </div>
    </div>

    <div class="diagnostics-meta" *ngIf="websocketDiagnostics?.lastEventAt">
      <span class="diagnostics-meta-label">Último evento</span>
      <span>
        {{ websocketDiagnostics?.lastEvent }} -
        {{ websocketDiagnostics?.lastEventAt | date: 'dd/MM/yyyy HH:mm:ss' }}
      </span>
    </div>

    <div class="diagnostics-meta" *ngIf="websocketDiagnostics?.reconnectScheduledAt">
      <span class="diagnostics-meta-label">Próxima reconexión</span>
      <span>{{ websocketDiagnostics?.reconnectScheduledAt | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
    </div>


    <div class="diagnostics-meta" *ngIf="websocketDiagnostics?.lastActivityAt">
      <span class="diagnostics-meta-label">Última actividad</span>
      <span>{{ websocketDiagnostics?.lastActivityAt | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
    </div>

    <div class="diagnostics-meta diagnostics-error" *ngIf="websocketDiagnostics?.inactivityDetected">
      <span class="diagnostics-meta-label">Inactividad detectada</span>
      <span>
        {{ websocketDiagnostics?.inactivityDetected }}
        <span *ngIf="websocketDiagnostics?.inactivityDetectedAt">
          - {{ websocketDiagnostics?.inactivityDetectedAt | date: 'dd/MM/yyyy HH:mm:ss' }}
        </span>
      </span>
    </div>

    <div class="diagnostics-meta diagnostics-error" *ngIf="websocketDiagnostics?.lastErrorMessage">
      <span class="diagnostics-meta-label">Último error</span>
      <span>
        {{ websocketDiagnostics?.lastErrorMessage }}
        <span *ngIf="websocketDiagnostics?.lastErrorAt">
          - {{ websocketDiagnostics?.lastErrorAt | date: 'dd/MM/yyyy HH:mm:ss' }}
        </span>
      </span>
    </div>

    <div class="diagnostics-meta" *ngIf="websocketDiagnostics?.lastCloseReason">
      <span class="diagnostics-meta-label">Último cierre</span>
      <span>
        Codigo {{ websocketDiagnostics?.lastCloseReason }}
        <span *ngIf="websocketDiagnostics?.lastCloseAt">
          - {{ websocketDiagnostics?.lastCloseAt | date: 'dd/MM/yyyy HH:mm:ss' }}
        </span>
      </span>
    </div>

    <div class="diagnostics-actions">
      <p-button
        label="Reconectar"
        class="text-button"
        [outlined]="true"
        icon="pi pi-refresh"
        (onClick)="reconnectWebSocket()"
        [disabled]="!selectedRoad"
      />
    </div>
    
  </div>
</p-overlayPanel>
<!-- websocket state overlay panel -->

<road-info-panel #roadInfoPanel [road]="selectedRoad" [roles]="userRoles"></road-info-panel>
